import React, {lazy} from 'react';
import styled from "styled-components";
import {
    ClickableDiv,
    FlexRowSection,
    SeparatorVertical,
    SeparatorVerticalDiv,
    SmallText, TinyText
} from "../../styles/globalStyles";
import {useDispatch, useSelector} from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import useScreenSize from "../../helpers/hooks/useScreenSize";
import {SITE_REFERER} from "@arboxappv4/shared/src/constants/constants";
import {changeLangByCode} from "../../helpers/i18n";
import {handleEnterClick, isLocationIL} from "../../helpers/functions";
import {t} from "i18next";
import {useNavigate} from "react-router-dom";
import {projectTypeMainSlice, projectTypes} from "@arboxappv4/shared/src/helpers/constants";

const LogoBlack = lazy(() => import(/* webpackChunkName: "LogoBlack" */'../../svg/LogoBlack'));


const Footer = (props) => {
    const { width, showOnlyPoweredBy, hidePoweredByMobile } = props;
    const project_type = useSelector(state => state.project?.project_type)
    const box = useSelector(state => state[projectTypeMainSlice[project_type]]?.box)
    const referrer = useSelector(state => state.site?.referrer)
    const language = useSelector(state => state[projectTypeMainSlice[project_type]]?.language)
    const {isMobile} = useScreenSize();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const displayBoxInfo = (referrer === SITE_REFERER) || (project_type === projectTypes.kiosk)

    const goToArboxSite = () => {
        if(isLocationIL()) {
            window.open('https://www.arbox.co.il/')
        } else {
            window.open('https://www.arboxapp.com/')
        }
    }

    return (
        <Wrapper width={width}>
            {!hidePoweredByMobile &&
            <PoweredBy onClick={goToArboxSite} onKeyDown={(e) => handleEnterClick(e, goToArboxSite)} gap={isMobile ? '6px' : '10px'} isMobile={isMobile} role="button" tabIndex={0}>
                <div style={{fontSize: isMobile ? '12px': '16px'}}>{t('poweredBy')}</div>
                <LogoBlack width={isMobile ? '45px' : '70px'}/>
            </PoweredBy>
            }
            {!showOnlyPoweredBy &&
            <InfoDiv isMobile={isMobile}>
                {displayBoxInfo && box?.email &&
                <IconTextDiv onClick={() => window.open(`mailto:${box.email}`)} onKeyDown={(e) => handleEnterClick(e, () => window.open(`mailto:${box.email}`))} role="button" tabIndex={0}>
                    <FontAwesomeIcon icon={light('envelope')}/>
                    <SmallText>{box.email}</SmallText>
                </IconTextDiv>
                }
                {displayBoxInfo && box?.phone &&
                <IconTextDiv onClick={() => window.open(`tel:${box.phone}`)} onKeyDown={(e) => handleEnterClick(e, () => window.open(`tel:${box.phone}`))} role="button" tabIndex={0}>
                    <FontAwesomeIcon icon={light('phone')}/>
                    <SmallText>{box.phone}</SmallText>
                </IconTextDiv>
                }
                {!isMobile && isLocationIL() &&
                <FlexRowSection gap={'10px'}>
                    <LangOption selected={language?.code === 'en'} onClick={() => changeLangByCode('en', dispatch, navigate)} onKeyDown={(e) => handleEnterClick(e, () => changeLangByCode('en', dispatch, navigate))} role="button" tabIndex={0}>EN</LangOption>
                    <SeparatorVerticalDiv />
                    <LangOption selected={language?.code === 'he'} onClick={() => changeLangByCode('he', dispatch, navigate)} onKeyDown={(e) => handleEnterClick(e, () => changeLangByCode('he', dispatch, navigate))} role="button" tabIndex={0}>עב</LangOption>
                </FlexRowSection>
                }
            </InfoDiv>
            }
        </Wrapper>
    );
};

export default Footer;

const Wrapper = styled.div`
    display: flex;
    height: 100%;
    width: ${({width}) => width};
    align-items: center;
    justify-content: space-between;
`;

const InfoDiv = styled.div`
    align-items: ${({isMobile}) => isMobile ? 'start' : 'center'};
    gap: ${({isMobile}) => isMobile ? '15px' : '30px'};
    flex-direction: ${({isMobile}) => isMobile ? 'column' : 'row'};
    display: flex
`;

const IconTextDiv = styled.div`
    align-items: center;
    gap: 10px;
    flex-direction: row;
    display: flex;
    cursor: pointer;
`;

const LangOption = styled(ClickableDiv)`
    height: 20px;
    text-decoration: ${({selected}) => selected ? 'underline' : 'none'};
`;

const PoweredBy = styled(FlexRowSection)`
    justify-content: ${({isMobile}) => isMobile ? 'center' : 'initial'};
    cursor: pointer;
`;